import apiClient from './client';

export function downloadInspectionWorkbook(inspectionIds) {
  return apiClient.post('/sport-ireland/inspections/workbook', { inspectionIds }, { responseType: 'blob' });
}

export function downloadSportIrelandWorkbook(zoneId, from, to) {
  return apiClient.get(`/sport-ireland/trails/${encodeURIComponent(zoneId)}/workbook`, {
    params: { from, to },
    responseType: 'blob',
  });
}
